import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { SITE_CONFIG } from '../config';
import { useTheme } from '../contexts/ThemeContext';
import './AgentInfo.css';

const AgentInfo = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  
  useEffect(() => {
    document.body.classList.remove('intro-active');
    document.body.style.overflow = 'auto';
    document.body.style.position = '';
    
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className={`agent-info-page ${isDarkMode ? 'dark-mode' : ''}`}>
      <Helmet>
        <title>About Andy Osburn - Real Estate Agent in Tulsa</title>
        <meta name="description" content="Meet Andy Osburn, your trusted real estate agent in Tulsa Metro. Over 34 years of experience in residential, commercial, and asset management." />
      </Helmet>
      
      <div className="agent-info-container">
        <button className="back-button" onClick={() => navigate('/')}>
          ← Back to Home
        </button>
        
        <div className="agent-profile-section">
          <div className="agent-photo">
            <img src="https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/a.osburn.tulsa_83f6d352fdda4d9b8cb1615a19b9d607.jpg" alt={SITE_CONFIG.AGENT.NAME} />
          </div>
          
          <div className="agent-details">
            <h1>Andy Osburn</h1>
            <p className="agent-title">Associate Realtor & Asset Management Specialist</p>
            <p className="agent-location">Tulsa Metro, Oklahoma</p>
            
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <a href="mailto:osburnandy@gmail.com">osburnandy@gmail.com</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <a href="tel:(918) 637-7826">(918) 637-7826</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">🏢</span>
                <span>MLS ID 110594</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="agent-bio-section">
          <h2>Andy Osburn | Professional Profile</h2>
          <div className="bio-content">
            <p>
              With over 34 years of experience in the real estate industry, Andy Osburn is a seasoned professional serving the Tulsa metro area with TRESCO, LLC and Fox + Associates. His career is defined by a deep versatility, having successfully navigated virtually every facet of the market—from residential and commercial sales to complex land development and asset management.
            </p>
            
            <h3>Deep Local Expertise</h3>
            <p>
              Andy has built a reputation as a trusted advisor in Tulsa and Broken Arrow, with extensive experience in neighborhoods like Prattville, Wedgewood, and Country Aire Estates. Having closed approximately 45 transactions with a specialized focus on single-family homes, condos, and commercial properties, he brings a data-driven approach to every deal, ensuring his clients maximize their investment potential.
            </p>
            
            <h3>A Comprehensive Skill Set</h3>
            <p>
              What sets Andy apart is his multi-disciplinary background. In addition to traditional brokerage, his professional toolkit includes:
            </p>
            <ul>
              <li><strong>Specialized Inspections:</strong> Serving as a Phase I Environmental Assessment Inspector.</li>
              <li><strong>Investment & Distressed Assets:</strong> Expertise in investment sales, foreclosures, and short sales.</li>
              <li><strong>Commercial & Land:</strong> Proven track record in land development, consulting, and landlord/tenant representation.</li>
            </ul>
            
            <h3>Education & Professional Standards</h3>
            <p>
              An alumnus of The University of Oklahoma, Andy combines academic grounding with decades of boots-on-the-ground knowledge. As a member of the National Association of REALTORS®, he is committed to the highest standards of ethics and a client-first philosophy. Whether you are a first-time homebuyer or a seasoned commercial investor, Andy's three decades of insight ensure a smooth and strategic transaction.
            </p>
          </div>
        </div>
        
        <div className="cta-section">
          <h2>Ready to Work Together?</h2>
          <p>Let's discuss your real estate goals and find the perfect community for you to call home.</p>
          <div className="cta-buttons">
            <a href="mailto:osburnandy@gmail.com?subject=Real Estate Inquiry" className="cta-button primary">
              Email Me
            </a>
            <button onClick={() => { navigate('/'); setTimeout(() => { window.dispatchEvent(new CustomEvent('openGlobeMap')); }, 100); }} className="cta-button secondary">
              View Properties
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentInfo;